import CloseIcon from "@mui/icons-material/Close";
import ProductCheckout from "../../assets/images/icons/ProductCheckoutIcon.svg";
import SignupUnderReviewIcon from "../../assets/images/icons/SignupUnderReviewIcon.svg";
import Constant from "../../Constant";
import ShoppingBagIcon from "../../assets/images/icons/ShoppingBagIcon.svg"

// Add interface for props
interface SignupSuccessPopupProps {
  onBrowseMarketPlace: () => void;
  onCancel: () => void;
  type: string; // 'under review' or 'rejected' or success
}

export default function SignupSuccessPopup({
  onBrowseMarketPlace,
  onCancel,
  type
}: SignupSuccessPopupProps) {

    
  return (
    <>
      <div
        className="modal modal__wd modal__wd--submitSellReq fade show barrel-assignment-modal signup-success-modal" // Added 'show'
        id="rejectUserModal"
        tabIndex={-1}
        aria-labelledby="rejectUserModalLabel"
        aria-hidden="false" // Changed from "true" to "false"
        style={{ display: "block" }} // Added to make modal visible
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header flex-row align-items-center justify-content-between">
              <h1 className="modal-title" id="rejectUserModalLabel">
                Signup Request
              </h1>
              <button
                type="button"
                className="pt-1 p-0 bg-transparent border-0 text-light"
                onClick={onCancel}
              >
                <CloseIcon />
              </button>
            </div>
            <div className="modal-body">
              <div className="text-center">
                <span className="warning-icon-wrapper">
                 {type == Constant.SIGNUP_POPUP_TYPE.REJECTED ? (<img src={ProductCheckout} alt="Product Checkout icon" />) : (<div className="rounded-pill success-smiley"><img src={SignupUnderReviewIcon} alt="Product Checkout icon" /></div>)} 
                </span>
              </div>
              <h2 className="modal-body__title">
                {type == Constant.SIGNUP_POPUP_TYPE.REJECTED ? "Looks Like It Didn’t Work Out" : "You’re Almost In!"}
              </h2>

              {/* <p className="modal-text">
                {type == Constant.SIGNUP_POPUP_TYPE.SUCCESS ? ("Thanks! Your request has been submitted and is now under review. You’ll be notified once your account is approved and activated")
                : (type == Constant.SIGNUP_POPUP_TYPE.PENDING_REVIEW ?
                    ("Thanks! Your signup request is already under review. You’ll be notified once your account is approved and activated.")
                    : ("Your signup request wasn’t approved this time. If you have questions, please contact our support team at <span>support@whitedogtradingpost.com</span>.")
                )}
                
              </p> */}
              <p className="modal-text">
                {type === Constant.SIGNUP_POPUP_TYPE.SUCCESS ? (
                  "Thanks! Your request has been submitted and is now under review. You’ll be notified once your account is approved and activated"
                ) : type === Constant.SIGNUP_POPUP_TYPE.PENDING_REVIEW ? (
                  "Thanks! Your signup request is already under review. You’ll be notified once your account is approved and activated."
                ) : (
                  <>
                    Your signup request wasn’t approved this time. If you have questions, please contact our support team at{" "}
                    <a className="email" href="mailto:support@whitedogtradingpost.com">
                      support@whitedogtradingpost.com
                    </a>.
                  </>
                )}
              </p>
            </div>
            <div className="modal-footer">
              <div className=" d-flex justify-content-center gap-2 flex-wrap w-100">
                <button
                  type="button"
                  className="btn secondary-btn px-5"
                  onClick={onCancel}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn primary-btn d-flex gap-2 justify-content-center"
                  onClick={onBrowseMarketPlace} // Added onClick handler
                >
                  <img src={ShoppingBagIcon} /> Marketplace
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Added modal backdrop */}
      <div className="modal-backdrop fade show"></div>
    </>
  );
}
